module.exports = __webpack_public_path__ + "media/images/icons/left-arrow-double-484008058ec4574cff33b0c450270208.svg";